module.exports = __webpack_public_path__ + "img/anbei.58f55c5c.png";